import React from 'react';
import { accountEntityReferenceAutocompletePersonOnlyFilter } from '../../../../../person/person';
import ContactFormWidget from '../../../../../production/resource/orders/editor/resourceOrderApprovalsStep/ContactFormWidget';
import EditablePanel, { EditablePanelProps } from '../../../../components/EditablePanel';
import { APPROVAL_EDITABLE_PANEL_HEADER_SX } from '../../../constants';
import { useCreateApprovalContext } from '../../hooks/useCreateApprovalContext';
import CreateApprovalFormEditablePanelHeader from '../CreateApprovalFormEditablePanelHeader';

export type ApprovalNotifyContactsFormFieldProps = Pick<EditablePanelProps, 'isCollapsable' | 'defaultCollapsed'>;

export default function ApprovalNotifyContactsFormField({
    isCollapsable,
    defaultCollapsed
}: ApprovalNotifyContactsFormFieldProps) {
    const { isSavingApprovalInput } = useCreateApprovalContext();

    return (
        <EditablePanel
            Header={<CreateApprovalFormEditablePanelHeader titleToken={'approval.notify.header'} />}
            isCollapsable={isCollapsable}
            defaultCollapsed={defaultCollapsed}
            headerSx={APPROVAL_EDITABLE_PANEL_HEADER_SX}
        >
            <ContactFormWidget
                name={'notifyContacts'}
                filter={accountEntityReferenceAutocompletePersonOnlyFilter}
                disabled={isSavingApprovalInput}
            />
        </EditablePanel>
    );
}
